export default "__VITE_ASSET__LgsmL9eo__"